import React, { useEffect, useState } from 'react';
import Userdiv from '../../components/userdiv';
import supabase from '../../supabase';
import FullPageLoader from '../../components/FullPageLoader';
import { Helmet } from 'react-helmet-async';

const countriesList = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Argentina", "Armenia",
  "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados",
  "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina",
  "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde",
  "Cambodia", "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China",
  "Colombia", "Comoros", "Congo (Congo-Brazzaville)", "Costa Rica", "Croatia", "Cuba",
  "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic",
  "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini",
  "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana",
  "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras",
  "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy",
  "Ivory Coast", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kuwait",
  "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein",
  "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta",
  "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova",
  "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru",
  "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea",
  "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Palestine", "Panama",
  "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar",
  "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia",
  "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe",
  "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore",
  "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Korea",
  "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland",
  "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga",
  "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine",
  "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan",
  "Vanuatu", "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe", "Unknown"
];



export default function Settingspage() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [fullName, setFullName] = useState('');
  const [country, setCountry] = useState('');
  const [reviewCount, setReviewCount] = useState(0);
  const [toast, setToast] = useState({ message: '', type: '' });
const [passwords, setPasswords] = useState({ current: '', new: '', confirm: '' });
  const [passLoading, setPassLoading] = useState(false);


  // Helper to show minimalist notification
  const notify = (message, type = 'success') => {
    setToast({ message, type });
    setTimeout(() => setToast({ message: '', type: '' }), 3500);
  };

  useEffect(() => {
    const fetchReviewCount = async () => {
      if (user?.id) {
        const { count, error } = await supabase
          .from('reviews')
          .select('*', { count: 'exact', head: true })
          .eq('user_id', user.id);
        if (!error) setReviewCount(count);
      }
    };
    fetchReviewCount();
  }, [user]);

  useEffect(() => {
    const checkSession = async () => {
      const { data } = await supabase.auth.getSession();
      setIsLoggedIn(!!data.session);
    };
    checkSession();
  }, []);

  useEffect(() => {
    const fetchUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (user) {
        setUser(user);
        // Prioritize database 'users' table data over metadata if possible
        const { data: dbUser } = await supabase.from('users').select('*').eq('id', user.id).single();
        if (dbUser) {
          setCountry(dbUser.country || 'Unknown');
          setFullName(dbUser.fullname || '');
        } else {
          setCountry(user?.user_metadata?.country || 'Unknown');
          const fname = user.user_metadata?.name || '';
          const lname = user.user_metadata?.lastname || '';
          setFullName(`${fname} ${lname}`.trim());
        }
      }
    };
    fetchUser();
  }, []);

  const handleSave = async () => {
    if (!user?.id) return notify("Session expired", "error");

    // Only updating Country in the database since Name/Status are locked
    const { error: usersError } = await supabase
      .from('users')
      .update({ country: country })
      .eq('id', user.id);

    if (usersError) {
      notify("Failed to update country.", "error");
      return;
    }

    // Keep Auth Metadata in sync
    await supabase.auth.updateUser({
      data: { country: country }
    });

    // Update reviews table (country only, name is locked in reviews usually)
    await supabase.from('reviews').update({ countr: country }).eq('user_id', user.id);

    notify("Changes saved successfully");
  };

  const handleProfileImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file || !user?.id) return;

    const fileExt = file.name.split('.').pop();
    const fileName = `${user.id}_${Date.now()}.${fileExt}`;
    const filePath = `profile/${fileName}`;

    const { error: uploadError } = await supabase.storage
      .from('companyimages')
      .upload(filePath, file);

    if (uploadError) {
      notify('Image upload failed', 'error');
      return;
    }

    const publicUrl = `https://wnjcqclqpgqdyyomobeh.supabase.co/storage/v1/object/public/companyimages/${filePath}`;

    const { error: updateError } = await supabase
      .from('users')
      .update({ img: publicUrl })
      .eq('id', user.id);

    if (updateError) {
      notify('Failed to save image URL.', 'error');
    } else {
      notify('Profile picture updated');
      setTimeout(() => window.location.reload(), 1000);
    }
  };

  const handleUpdatePassword = async () => {
    if (passwords.new.length < 8) return notify("Password must be 8+ characters", "error");
    if (passwords.new !== passwords.confirm) return notify("Passwords do not match", "error");
    if (!passwords.current) return notify("Please enter current password", "error");

    setPassLoading(true);
    try {
      // Step 1: Re-authenticate
      const { error: reAuthError } = await supabase.auth.signInWithPassword({
        email: user.email,
        password: passwords.current,
      });

      if (reAuthError) throw new Error("Current password incorrect");

      // Step 2: Update
      const { error: updateError } = await supabase.auth.updateUser({
        password: passwords.new
      });

      if (updateError) throw updateError;

      notify("Password updated successfully");
      setPasswords({ current: '', new: '', confirm: '' });
    } catch (err) {
      notify(err.message, "error");
    } finally {
      setPassLoading(false);
    }
  };

  const handleDeleteProfileImage = async () => {
    if (!user?.id) return;
    const { error } = await supabase.from('users').update({ img: null }).eq('id', user.id);

    if (error) {
      notify('Failed to remove image.', 'error');
    } else {
      notify('Image removed');
      setTimeout(() => window.location.reload(), 1000);
    }
  };

  if (isLoggedIn && !user) return <FullPageLoader />;
  if (!isLoggedIn) return <FullPageLoader />;

  return (
    <div className='w-full 2xl:max-w-full bg-[#f3f3f3] 2xl:mx-auto pb-[100px]'>
      <Helmet>
        <title>Settings | Sitemanifest</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      {toast.message && (
        <div className={`fixed bottom-10 left-1/2 transform -translate-x-1/2 px-8 py-3 rounded-full shadow-2xl transition-all duration-500 z-[9999] font-jakarta text-[14px] font-medium tracking-wide flex items-center gap-3 animate-fade-in-up
          ${toast.type === 'error' ? 'bg-red-500 text-white' : 'bg-[#25c673] text-white'}`}>
          {toast.type === 'error' ? '✕' : '✓'} {toast.message}
        </div>
      )}

      <div className='w-full 2xl:max-w-[1440px] 2xl:mx-auto'>
        <div className='w-full px-[24px] pt-[40px] xs:pt-[70px] lg:pt-[90px] xl:pt-[80px] flex xs:flex-row xs:items-start flex-col gap-[50px] mt-[50px] items-center'>
          
          {/* Main Card Container - Adjusted height for extra fields */}
          <div className='flex w-full transform relative shadow-md max-w-[640px] mx-auto -rotate-[1deg] flex-col min-h-[750px] 2xl:min-h-[820px] bg-yellowomoregreen mb-20'>
            <div className='absolute flex flex-col w-full px-[17px] py-[25px] min-h-[730px] 2xl:h-auto border-none bg-white top-[10px] rounded-[3px] rotate-[1deg] transform'>
              
              <div className='flex flex-col gap-[20px]'>
                <h1 className='font-staat text-[20px] 2xl:text-[32px] text-black tracking-[1px]'>Personal settings</h1>
                <div className='flex flex-col gap-[12px]'>
                  <label className='w-[211px] hover:scale-105 transition duration-300 h-[42px] bg-[#506E5F] rounded-[8px] text-white font-staat text-[14px] tracking-[1px] lg:w-[240px] 2xl:text-[18px] 2xl:h-[55px] 2xl:w-[300px] flex items-center justify-center cursor-pointer'>
                    Upload new profile picture
                    <input type="file" accept="image/*" onChange={handleProfileImageUpload} className="hidden" />
                  </label>
                  <button onClick={handleDeleteProfileImage} className='w-[211px] hover:bg-opacity-90 h-[42px] bg-[#506E5F] rounded-[8px] text-white font-staat text-[14px] tracking-[1px] lg:w-[240px] 2xl:text-[18px] 2xl:h-[55px] 2xl:w-[300px]'>
                    Delete current profile picture
                  </button>
                </div>
              </div>

              {/* Information Section */}
              <div className='flex flex-col mt-[25px] gap-[12px] 2xl:pr-[50px]'>
                <div className='flex flex-col gap-[8px]'>
                  <span className='text-[14px] font-staat text-[#323232] tracking-[1px] uppercase opacity-60'>Email & Name</span>
                  <input value={user?.email || ''} readOnly className='w-full outline-none text-[12px] tracking-[1px] font-light text-black px-[14px] font-jakarta h-[40px] rounded-[7px] bg-[#f0f0f0] opacity-50 cursor-not-allowed' type="email" />
                  <input value={fullName} readOnly className='w-full outline-none text-[12px] tracking-[1px] font-light text-black px-[14px] h-[40px] font-jakarta rounded-[7px] bg-[#f0f0f0] opacity-50 cursor-not-allowed' type="text" />
                </div>

                <div className='flex flex-col gap-[8px]'>
                  <span className='text-[14px] font-staat text-[#323232] tracking-[1px] uppercase opacity-60'>Country</span>
                  <select value={country} onChange={(e) => setCountry(e.target.value)} className='w-full text-[12px] outline-none tracking-[1px] font-light text-black px-[14px] font-jakarta h-[40px] rounded-[7px] border border-gray-100 bg-[#f9f9f9] cursor-pointer'>
                    {countriesList.map((c) => (
                      <option key={c} value={c}>{c}</option>
                    ))}
                  </select>
                </div>

                <button onClick={handleSave} className='font-staat hover:bg-opacity-90 transition duration-300 w-full max-w-[210px] h-[45px] bg-[#25c673] text-white tracking-[1px] rounded-[8px] mt-2'>
                  Save basic information
                </button>

                <hr className='my-6 border-gray-100' />

                {/* SECURITY SECTION */}
                <div className='flex flex-col gap-[15px] bg-gray-50 p-4 rounded-xl'>
                  <span className='text-[16px] font-staat text-black tracking-[1px]'>Update Security</span>
                  
                  <div className='flex flex-col gap-[5px]'>
                    <label className='text-[10px] font-bold text-gray-400 uppercase'>Current Password</label>
                    <input type="password" placeholder="••••••••" value={passwords.current} onChange={e => setPasswords({...passwords, current: e.target.value})} className='w-full outline-none text-[12px] tracking-[1px] px-[14px] font-jakarta h-[40px] rounded-[7px] border border-gray-200 focus:border-[#506E5F]' />
                  </div>

                  <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                    <div className='flex flex-col gap-[5px]'>
                      <label className='text-[10px] font-bold text-gray-400 uppercase'>New Password (8+)</label>
                      <input type="password" placeholder="••••••••" value={passwords.new} onChange={e => setPasswords({...passwords, new: e.target.value})} className='w-full outline-none text-[12px] tracking-[1px] px-[14px] font-jakarta h-[40px] rounded-[7px] border border-gray-200 focus:border-[#506E5F]' />
                    </div>
                    <div className='flex flex-col gap-[5px]'>
                      <label className='text-[10px] font-bold text-gray-400 uppercase'>Repeat New</label>
                      <input type="password" placeholder="••••••••" value={passwords.confirm} onChange={e => setPasswords({...passwords, confirm: e.target.value})} className='w-full outline-none text-[12px] tracking-[1px] px-[14px] font-jakarta h-[40px] rounded-[7px] border border-gray-200 focus:border-[#506E5F]' />
                    </div>
                  </div>

                  <button onClick={handleUpdatePassword} disabled={passLoading || !passwords.new} className='font-staat hover:bg-black transition duration-300 w-full h-[45px] bg-black text-white tracking-[1px] rounded-[8px] disabled:opacity-30'>
                    {passLoading ? 'Verifying...' : 'Change Password'}
                  </button>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>

      <style>{`
        @keyframes fade-in-up {
          0% { opacity: 0; transform: translate(-50%, 20px); }
          100% { opacity: 1; transform: translate(-50%, 0); }
        }
        .animate-fade-in-up {
          animation: fade-in-up 0.4s ease-out forwards;
        }
      `}</style>
    </div>
  );
}